import moment from 'moment/moment'
import { AutocompleteOption } from 'shared/components/Autocomplete'

export const AutoCancelingOptions: readonly AutocompleteOption[] = [
    { label: '-', value: '-1' },
    { label: 'Не выбрано', value: '0' },
    { label: '15 мин', value: '15' },
    { label: '30 мин', value: '30' },
    { label: '1 час', value: '60' },
    { label: '2 часа', value: '120' },
    { label: '3 часа', value: '180' },
    { label: '4 часа', value: '240' },
    { label: '5 часов', value: '300' },
    { label: '6 часов', value: '360' },
    { label: '12 часов', value: '720' },
    { label: '1 день', value: '1440' },
    { label: '2 дня', value: '2880' },
    { label: '3 дня', value: '4320' },
    { label: '4 дня', value: '5760' },
    { label: '5 дней', value: '7200' },
    { label: '6 дней', value: '8640' },
    { label: '7 дней', value: '10080' },
] as const

export const buildExpireTime = (
    expireIn: number | null,
    createdAt?: Date | null,
) => {
    if (expireIn == null) {
        return {}
    }

    if (expireIn === 0) {
        return { expireTime: null }
    }

    if (expireIn === -1) {
        return {}
    }

    return {
        expireTime: moment(createdAt).add(expireIn, 'minutes').toISOString(),
    }
}

export const getNearestOption = (
    expire?: Date | null,
    createdAt?: Date | null,
) => {
    if (!expire) {
        return null
    }

    const eventCreated = moment(createdAt)
    const eventExpire = moment(expire)
    const diffMinutes = eventExpire.diff(eventCreated, 'minutes')

    const exactOption = AutoCancelingOptions.find(
        opt => Number(opt.value) === diffMinutes,
    )
    if (exactOption) {
        return exactOption
    }

    const sortedOptions = [...AutoCancelingOptions].sort(
        (a, b) => Number(a.value) - Number(b.value),
    )
    return sortedOptions.reduce((prev, curr) => {
        const prevDiff = Math.abs(Number(prev.value) - diffMinutes)
        const currDiff = Math.abs(Number(curr.value) - diffMinutes)
        return currDiff < prevDiff ? curr : prev
    })
}

export const getAvailableAutoCancelingOptions = (
    expire: Date | null,
): AutocompleteOption[] => {
    if (!expire) {
        return [...AutoCancelingOptions]
    }

    const now = moment()
    const eventExpire = moment(expire)
    const diffMinutes = eventExpire.diff(now, 'minutes')

    if (diffMinutes < 15) {
        return []
    }

    if (diffMinutes < 60) {
        return AutoCancelingOptions.filter(opt => {
            const optionMinutes = Number(opt.value)
            return optionMinutes <= diffMinutes
        })
    }

    if (diffMinutes < 1440) {
        return AutoCancelingOptions.filter(opt => {
            const optionMinutes = Number(opt.value)
            return optionMinutes <= diffMinutes && optionMinutes <= 720
        })
    }

    return AutoCancelingOptions.filter(opt => {
        const optionMinutes = Number(opt.value)
        return optionMinutes <= diffMinutes
    })
}

export const computeExpireTime = (date?: Date | null) => {
    if (!date) {
        return null
    }

    const now = moment()
    const future = moment(date)

    if (!future.isValid() || future.isBefore(now)) {
        return null
    }

    const diffMinutes = future.diff(now, 'minutes')

    if (diffMinutes < 60) {
        return `через ${diffMinutes} мин`
    }

    if (diffMinutes < 1440) {
        const hours = Math.floor(diffMinutes / 60)
        const minutes = diffMinutes % 60
        return minutes ? `через ${hours} ч ${minutes} мин` : `через ${hours} ч`
    }

    return `через ${moment.duration(diffMinutes, 'minutes').humanize(false)}`
}
